export const STORAGE_PREFIX =
  'https://storage.uk.cloud.ovh.net/v1/AUTH_948ebf6d457f4ea4802e51b22bfce599/mcpe-assets/';

export const VALID_ADDON_EXT = ['.mcworld', '.mcpack', '.mcaddon', '.mctemplate'];
export const VALID_IMG_EXT = ['.png', '.jpg', '.jpeg', '.webp'];